class LabGrownRingSizing extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.standardOption = this.querySelector('[data-ring-size-standard]');
    this.customOption = this.querySelector('[data-ring-size-custom]');
    this.customPanel = this.querySelector('[data-ring-size-custom-panel]');
    this.customInput = this.querySelector('[data-ring-size-custom-input]');
    this.propertyInput = this.querySelector('[data-ring-size-property]');

    if (
      !this.standardOption ||
      !this.customOption ||
      !this.customPanel ||
      !this.customInput ||
      !this.propertyInput
    ) {
      return;
    }

    this.standardRingSize = this.dataset.standardRingSize || this.propertyInput.value || 'M';

    this.standardOption.addEventListener('change', () => this.syncSizingMode());
    this.customOption.addEventListener('change', () => this.syncSizingMode(true));
    this.customInput.addEventListener('input', () => this.syncPropertyValue());

    this.dataset.initialized = 'true';
    this.syncSizingMode();
  }

  syncSizingMode(shouldFocus = false) {
    const customSizing = this.customOption.checked;

    this.customPanel.hidden = !customSizing;
    this.customInput.disabled = !customSizing;
    this.customInput.required = customSizing;
    this.customOption.setAttribute('aria-expanded', String(customSizing));

    if (customSizing) {
      this.syncPropertyValue();

      if (shouldFocus) {
        requestAnimationFrame(() => this.customInput.focus());
      }
    } else {
      this.customInput.setCustomValidity('');
      this.propertyInput.value = this.standardRingSize;
    }
  }

  syncPropertyValue() {
    const requestedSize = this.customInput.value.trim();
    this.propertyInput.value = requestedSize;
    this.customInput.setCustomValidity('');
  }
}

if (!customElements.get('lab-grown-ring-sizing')) {
  customElements.define('lab-grown-ring-sizing', LabGrownRingSizing);
}
